/* eslint-disable no-param-reassign */
/* @flow */

/**
 * export @effect decorator
 * the effect decorator marks a method as able to handle
 * state changes while giving off side effects.
 */
export function effect(_: Object, key: String, descriptor: Object): Object {
  const fn = descriptor.value;

  descriptor.value = () => {
    throw new Error('An effect method should not be called directly, use dispatcher shortcut');
  };

  descriptor.value._effect = {
    key,
    fn,
  };

  return descriptor;
}
